import { useParams } from "react-router-dom";

import RemotePage from "./RemotePage";

export default function RemoteApp({
  initialController = "",
  showHeader = true,
  standalone = false,
}) {
  const { controller } = useParams();

  return (
    <RemotePage
      initialController={controller || initialController}
      showHeader={showHeader}
      standalone={standalone}
    />
  );
}
